import { types } from 'mobx-state-tree';


const EXTERIOR_WALL_TYPES = {
    BRICK: 'brick',
    BRICK_VENEER: 'brick-veneer',
    CONCRETE: 'concrete',
    LOGS: 'logs',
    STONE: 'stone',
    STONE_VENEER: 'stone-veneer',
    STUCCO: 'stucco',
    VINYL_SIDING: 'vinyl-siding',
    WOOD_SIDING: 'wood-siding',
};

const ExteriorWallTypeEnum = types.enumeration('ExteriorWallType', Object.values(EXTERIOR_WALL_TYPES));

export {
    ExteriorWallTypeEnum,
};
export default EXTERIOR_WALL_TYPES;
